import { useState, useEffect } from "react";

/**
 * Custom hook for matching media queries.
 *
 * @example
 * // check if current device matches following media query
 * const isMediaSM = useMediaQuery("(min-width: 576px)");
 */
export const useMediaQuery = (query: string) => {
    const [matches, setMatches] = useState(false);

    useEffect(() => {
        const media = window.matchMedia(query);
        if (media.matches !== matches) {
            setMatches(media.matches);
        }
        const listener = () => setMatches(media.matches);
        window.addEventListener("resize", listener);
        return () => window.removeEventListener("resize", listener);
    }, [matches, query]);

    return matches;
};
